var projectTimeline = {
	"Project timeline": "Project timeline",
	"None planned": "None planned",
	"1-3 months": "1-3 months",
	"4-6 months": "4-6 months",
	"7-12 months": "7-12 months",
	"More than 1 year": "More than 1 year"
};

export { projectTimeline as default };
